import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  IHarvestResource,
  IMusselHarvest,
  IOysterHarvest,
} from '../../entities/growing.entities';
import { selectFarmsData } from '../../store/farms/farms.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { selectAccount } from '../../store/auth/auth.selector';
import { displayValueUnit } from '../../lib/common.helpers';
import { FarmDiv, LineDiv } from './CalendarCell';

interface Props {
  harvestData: IHarvestResource;
  onClickCell: (d: any) => void;
}

const HarvestCell = ({ harvestData, onClickCell }: Props) => {
  const lang = useSelector(selectLang);
  const farm = useSelector(selectFarmsData).find(
    x => x.id === harvestData.line.farm_id,
  );
  const line = farm?.lines.find(x => x.id === harvestData.line_id);
  const unitType = useSelector(selectAccount)?.display_unit;

  const handleClick = (event: any) => {
    event.preventDefault();
    onClickCell(harvestData);
  };

  return (
    <div className='--entity --harvest' onClick={handleClick.bind(this)}>
      <div className='--header'>
        <span>{translate(lang, 'harvest')}</span>
      </div>
      <div className='--title'>
        <div className='mt-7'>
          {harvestData.crop_type === 'MUSSEL'
            ? `${harvestData.season_name} - ${displayValueUnit(
                (harvestData as IMusselHarvest).amount,
                unitType,
                'weight_kg',
              )}`
            : `${harvestData.season_name} - ${
                (harvestData as IOysterHarvest).amount_dz
              } dz`}
        </div>
        <div className='d-flex flex-wrap gap-7'>
          {farm && <FarmDiv farm={farm} />}
          {line && <LineDiv line={line} />}
        </div>
      </div>
      <div className='--btn-bar'>
        <Link to={`/harvest/${harvestData.id}`} className='--view'>
          {translate(lang, 'View')}
        </Link>
      </div>
    </div>
  );
};

export default HarvestCell;
